export const openWindowInNewTab = (url: string): void => {
  const win = window.open(url, '_blank');
  if (win) {
    win.opener = null;
  }
};
